import { X, Check } from "lucide-react";
import Reveal, { Eyebrow } from "./Reveal";

const yes = [
  "Sei una donna e vuoi tonificare, non «sparire»",
  "Hai già provato diete lampo e hai ripreso tutto",
  "Ti alleni (o vorresti) ma non vedi cambiamenti",
  "Vuoi un metodo che stia dentro una vita piena: lavoro, famiglia, imprevisti",
];
const no = [
  "Cerchi -10 kg in un mese",
  "Vuoi un piano da 1200 calorie",
  "Pensi che più fatica = più risultati",
];

export default function ForWho() {
  return (
    <section className="py-24 sm:py-32" data-testid="for-who-section">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <Eyebrow>Per chi è</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight leading-[1.05] mt-4">
            Per le donne stanche di <em>ricominciare</em> ogni lunedì.
          </h2>
          <p className="mt-6 text-[#5A625C] leading-relaxed max-w-md">
            Fare una ricomposizione significa perdere grasso e costruire muscolo nello stesso momento. È un processo più
            lento di una dieta lampo, ed è proprio per questo che resta.
          </p>
        </Reveal>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
          <Reveal delay={0.1} className="bg-white border border-[#E5E1D8] rounded-3xl p-7">
            <p className="font-display text-2xl mb-5">È per te se…</p>
            <ul className="space-y-4">
              {yes.map((t) => (
                <li key={t} className="flex gap-3 text-[15px] leading-snug"><Check className="w-4 h-4 mt-0.5 text-[#748E63] shrink-0" />{t}</li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.2} className="rounded-3xl p-7 border border-dashed border-[#C05746]/40 sm:mt-12">
            <p className="font-display text-2xl mb-5">Non è per te se…</p>
            <ul className="space-y-4">
              {no.map((t) => (
                <li key={t} className="flex gap-3 text-[15px] leading-snug text-[#5A625C]"><X className="w-4 h-4 mt-0.5 text-[#C05746] shrink-0" />{t}</li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
